import React, { FC, ReactElement, useEffect, useState } from 'react';
import { Card, Container } from 'react-bootstrap';
import i18next from 'i18next';
import AccountSetupForm from './AccountSetupForm';
import { NavigateFunction, useNavigate } from 'react-router';
import { useExtendedAuth } from '../../util/auth0';
import LoadingSpinner from '../LoadingSpinner';

const AccountSetupPage: FC = (): ReactElement => {
  const navigate: NavigateFunction = useNavigate();
  const { isApprovedTherapist } = useExtendedAuth();
  const [isCheckingProfile, setIsCheckingProfile] = useState(true);

  useEffect(() => {
    const redirectApprovedTherapist = async (): Promise<void> => {
      if (await isApprovedTherapist()) {
        navigate('/patients', { replace: true });
        return;
      }
      setIsCheckingProfile(false);
    };
    void redirectApprovedTherapist();
  }, []);

  if (isCheckingProfile) {
    return <LoadingSpinner />;
  }

  return (
    <Container className="h-100">
      <div className="d-flex justify-content-md-center align-items-center vh-100">
        <Card>
          <Card.Body>
            <h3 className='fw-bold mb-3'>{i18next.t('accountSetup.personalDetailLabel')}</h3>
            <AccountSetupForm onSuccess={() => navigate('/patients')} />
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default AccountSetupPage;

